export {isValidEmailAddress} from '../../libs/shared/helpers/src/utilities/stringHelpers';

export class InvalidEmailAddressError extends Error {}
